import API from '@/views/Fdc/Apis'
import _ from 'lodash'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. calcCutOffSpec 변경 (BRIOQUE Grid version으로 처리 되도록) - 기능 검증
// FIXME: 2. cut off line 처리
// FIXME: 3. max variable count 기능 검증

/**
 * Analysis > Multivariate Analysis - Fearture Selection
 * Fearture Selection Tab
 */
export default {
  name: 'FeatureSelection',
  components: {
  },
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.briqueChart = BriqueChart
  },
  computed: {
  },
  watch: {
    /**
     * summaryData 변화 감지
     */
    summaryData () {
      this.rowData = []
      this.chartData = []
      this.selectionCount = null
    },
    /**
     * selectionCount 변화 감지
     * @param {*} value Importance Cutoff value
     * 선택된 조건에 따라 chart annotation을 다시 그립니다.
     */
    selectionCount (value) {
      if (!_.isEmpty(value)) this.calcCutOffSpec()
      // let s = this.$refs.featureGrid
      // let cutoff = false
      // for (let i in s.rows) {
      //   if (s.rows[i] && s.rows[i].dataItem) {
      //     s.rows[i].dataItem._status.checked = (Number(s.rows[i].dataItem.index) > Number(value) && Number(i) < Number(this.maxVariableCount))
      //     if (cutoff === false && Number(s.rows[i].dataItem.index) < Number(value)) {
      //       if (i > 0) {
      //         this.xCutoffValue = i - 1
      //         this.yCutoffValue = s.rows[i - 1].dataItem.index
      //       } else {
      //         this.xCutoffValue = null
      //         this.yCutoffValue = null
      //       }
      //       cutoff = true
      //     }
      //   }
      // }
      // // this.chartKey += 1
      // setTimeout(() => {
      //   this.drawChartArea()
      //   this.featureGrid.collectionView.refresh()
      // }, 30)
    },
    /**
     * maxVariableCount 변화 감지
     * @param {*} value Max Variable Count value
     * 선택된 조건에 따라 chart annotation을 다시 그립니다.
     */
    maxVariableCount (value) {
      if (!_.isEmpty(value)) this.calcCutOffSpec()
      // let s = this.$refs.featureGrid
      // let cutoff = false
      // for (let i in s.rows) {
      //   if (s.rows[i] && s.rows[i].dataItem) {
      //     s.rows[i].dataItem._status.checked = (Number(s.rows[i].dataItem.index) > Number(this.selectionCount) && Number(i) < Number(value))
      //     if (cutoff === false && Number(s.rows[i].dataItem.index) < Number(this.selectionCount)) {
      //       if (i > 0) {
      //         this.xCutoffValue = i - 1
      //         this.yCutoffValue = s.rows[i - 1].dataItem.index
      //       } else {
      //         this.xCutoffValue = null
      //         this.yCutoffValue = null
      //       }
      //       cutoff = true
      //     }
      //   }
      // }
      // // this.chartKey += 1
      // setTimeout(() => {
      //   this.drawChartArea()
      //   this.featureGrid.collectionView.refresh()
      // }, 30)
    }
  },
  props: {
    summaryData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  methods: {
    /**
     * Columns initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', flex: 1, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', flex: 1, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', flex: 1, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VARIABLE'), field: 'variable', flex: 1, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', flex: 4, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: 4, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUMMARY_TYPE'), field: 'summaryType', flex: 2 },
        {
          headerName: this.$t('fdc.COMMON.COLUMN.INDEX'),
          field: 'index',
          flex: 1,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return Math.round(params.value * 10000) / 10000
          }
        } // format: 'n4'
      ]
    },
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * Feature Selection 조회
     */
    async searchFeatureImportance () {
      this.$emit('reset-data')

      const paramPayload = {
        fab: this.summaryData.fab,
        eqpId: this.summaryData.eqpId,
        moduleId: this.summaryData.moduleId
      }
      let paramList = await API.BaseInfo.getEqpParams(paramPayload)
      this.paramList = paramList

      const payload = {
        paramData: {
          fab: this.summaryData.fab,
          eqpId: this.summaryData.eqpId,
          moduleId: this.summaryData.moduleId,
          fromDate: this.summaryData.fromDate,
          toDate: this.summaryData.toDate
        }
      }

      await API.Analysis.runFeatureSelection(payload, this.callback)
    },
    /**
     * Feature Selection 조회 callback
     * @param {Object} searchData Feature Selection 조회 결과
     */
    callback (searchData) {
      this.rowData = []
      this.chartData = []
      this.selectionCount = null
      if (searchData.summaryDataList == null) {
        return
      }

      this.summaryData.summaryDataList = searchData.summaryDataList
      this.summaryData.featureImportance = searchData.featureImportance
      this.summaryData.featureImportance.featureImportanceList.forEach(element => {
        const featureImportance = _.clone(element)
        // paramName으로 aliasName 검색
        let filterParamList = this.paramList.filter(param => param.paramName === featureImportance.paramName)
        if (filterParamList.length > 0) {
          featureImportance.aliasName = filterParamList[0].aliasName
        } else {
          // alias name이 없을 경우에는 임시로 paramName으로 처리
          featureImportance.aliasName = featureImportance.paramName
        }

        this.rowData.push(featureImportance)
      })
      this.chartData = searchData.variableImportanceChart

      this.selectionCount = Math.round(this.summaryData.featureImportance.varImportanceCutOff * 10000) / 10000.0

      setTimeout(() => {
        this.calcCutOffSpec()
        // this.drawChartAnnotation()
        this.drawChartArea()
      }, 30)
    },
    /**
    * Run Button 클릭
    */
    clickRun () {
      this.searchFeatureImportance()

      // this.drawChartArea()
    },
    /**
     * 차트 영역 계산
     * chart의 y축 Min/Max값을 설정합니다.
     */
    drawChartArea () {
      if (this.chartData.x && this.chartData.y) {
        let traces = [
          {
            name: 'Importance Index',
            type: 'bar',
            x: this.chartData.x,
            y: this.chartData.y,
            hovertemplate: '<b>Parameter Name:</b> %{text.paramName}<br><b>Step Id:</b> %{text.stepId}<br><b>Summary Type:</b> %{text.summaryType}<br><b>Index:</b> %{y:.4f}<extra></extra>',
            text: this.chartData.text
          }
        ]
        let layout = {
          title: this.chartTitle,
          xaxis: {
            tickangle: 'auto'
          },
          legend: {
            // orientation: 'h',
            // y: 1.2
          },
          margin: {
            b: 200
          },
          shapes: [],
          hoverlabel: {
            align: 'left'
          },
          showlegend: true
        }
        let config = {
          responsive: true,
          scrollZoom: true,
          displaylogo: false,
          displayModeBar: true
        }
        let promise = BriqueChart.newPlot('featureChart', traces, layout, config)

        promise.then(() => {
          this.drawChartAnnotation()
        })
      }

      // let yMin = 0; let yMax = 100; let margin = 0; const yValues = this.chartData.map(function (o) { return o.index })
      // yMax = Math.max(...yValues)
      // yMin = Math.min(...yValues)
      // margin = (yMax - yMin) * 0.2
      // this.yMin = yMin - margin
      // this.yMax = yMax + margin
    },
    /**
     * Next Step Button 클릭
     * PCA step으로 단계를 넘깁니다.
     */
    clickNextStep () {
      if (this.$refs.featureGrid.checkedRowCount < 3) {
        this.$dialog.alert(this.$t('fdc.STATS_ANALYSIS.MESSAGE.INFORM_NOT_SELECT_THREE_FEATURE'))
      } else {
        this.$emit('tab-selected', 1)
      }
    },
    /**
     * null 값 check
     * @param {*} value check value
     */
    // isEmpty (value) {
    //   if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    /**
     * Draw Chart Annotation
     */
    drawChartAnnotation () {
      if (this.xCutoffValue === null || this.yCutoffValue === null) return
      let element = document.querySelector('#featureChart')
      if (_.isEmpty(element)) return
      let layout = element.layout
      if (_.isEmpty(layout)) return
      layout.shapes = [
        {
          type: 'line',
          xref: 'x',
          x0: this.xCutoffValue,
          x1: this.xCutoffValue,
          yref: 'paper',
          y0: 0,
          y1: 1,
          line: { color: 'red', width: 2 }
        }, {
          type: 'line',
          xref: 'paper',
          x0: 0,
          x1: 1,
          yref: 'y',
          y0: this.yCutoffValue,
          y1: this.yCutoffValue,
          line: { color: 'red', width: 2 }
        }
      ]
      let promise = BriqueChart.relayout('featureChart', layout)
      promise.then(() => {
        // if (this.featureGrid.collectionView !== null) {
        //   this.featureGrid.collectionView.refresh()
        // }
      })

      // if (this.xCutoffValue !== null && this.yCutoffValue !== null) {
      //   new annotation.AnnotationLayer(this.featureChart, [
      //     {
      //       type: 'Line',
      //       attachment: 'DataCoordinate',
      //       position: 'Center',
      //       start: { x: this.xCutoffValue, y: 0 },
      //       end: { x: this.xCutoffValue, y: 1 },
      //       style: { stroke: 'red', strokeWidth: 2 },
      //       tooltip: 'Cutoff'
      //     },
      //     {
      //       type: 'Line',
      //       attachment: 'DataCoordinate',
      //       position: 'Center',
      //       start: { x: 0, y: this.yCutoffValue },
      //       end: { x: this.chartData.length, y: this.yCutoffValue },
      //       style: { stroke: 'red', strokeWidth: 2 },
      //       tooltip: 'Cutoff'
      //     }
      //   ])
      // }
      // [2020.06 brique]
      //    cutoff와 variable select 시점이 다른경우 spec 선 추가 필요???
      //    grid check 여부를 확인하다가 uncheck 되는 시점에서 row index -1 시점에 spec 선 긋기
      // if (this.xCutoffValue !== null && this.yCutoffValue !== null) {
      //   new annotation.AnnotationLayer(this.featureChart, [
      //     {
      //       type: 'Line',
      //       attachment: 'DataCoordinate',
      //       position: 'Center',
      //       start: { x: this.xCutoffValue - 5, y: 0 },
      //       end: { x: this.xCutoffValue - 5, y: 1 },
      //       style: { stroke: 'red', strokeWidth: 2 },
      //       tooltip: 'Selected Variable',
      //       content: 'Selected Variable'
      //     }
      //   ])
      // }
    },
    /**
     * Importance Cutoff spec line 관련 data 계산
     */
    calcCutOffSpec () {
      let grid = this.$refs.featureGrid
      const model = grid.gridApi.getModel()
      // let featureLength = grid.getAllRows().length
      let featureLength
      let cutoff = false

      if (model) {
        featureLength = model.getRowCount()
        for (let i = 0; i < featureLength; i++) {
          const node = model.getRow(i)
          let item = node.data
          if ((Number(item.index) > Number(this.selectionCount) && Number(i) < Number(this.maxVariableCount))) {
            node.setSelected(true)
          } else {
            node.setSelected(false)
          }
          if (cutoff === false && Number(item.index) < Number(this.selectionCount)) {
            if (i > 0) {
              this.xCutoffValue = i - 1
              this.yCutoffValue = item.index
            } else {
              this.xCutoffValue = null
              this.yCutoffValue = null
            }
            cutoff = true
          } else if (cutoff === false && Number(i) === Number(this.maxVariableCount)) {
            if (i > 0) {
              this.xCutoffValue = i - 1
              this.yCutoffValue = item.index
            } else {
              this.xCutoffValue = null
              this.yCutoffValue = null
            }
            cutoff = true
          }

          if (cutoff === false && (featureLength - 1) === Number(i)) {
            this.xCutoffValue = i
            this.yCutoffValue = item.index
            cutoff = true
          }
        }
      }

      // let i = 0
      // grid.gridApi.forEachNode(node => {
      //   let item = node.data
      //   if ((Number(item.index) > Number(this.selectionCount) && Number(i) < Number(this.maxVariableCount))) {
      //     node.setSelected(true)
      //   }
      //   if (cutoff === false && Number(item.index) < Number(this.selectionCount)) {
      //     if (i > 0) {
      //       this.xCutoffValue = i - 1
      //       this.yCutoffValue = item.index
      //     } else {
      //       this.xCutoffValue = null
      //       this.yCutoffValue = null
      //     }
      //     cutoff = true
      //   } else if (cutoff === false && Number(i) === Number(this.maxVariableCount)) {
      //     if (i > 0) {
      //       this.xCutoffValue = i - 1
      //       this.yCutoffValue = item.index
      //     } else {
      //       this.xCutoffValue = null
      //       this.yCutoffValue = null
      //     }
      //     cutoff = true
      //   }

      //   if (cutoff === false && (featureLength - 1) === Number(i)) {
      //     this.xCutoffValue = i
      //     this.yCutoffValue = item.index
      //     cutoff = true
      //   }
      //   i++
      // })

      setTimeout(() => {
        this.drawChartArea()
      }, 30)
    }
  },
  data () {
    return {
      selectionCount: null, // Importance Cutoff value
      columns: [], // Feature Selection grid column 배열
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // Feature Selection grid row data
      chartTitle: this.$t('fdc.STATS_ANALYSIS.LABEL.VARIABLE_IMPORTANCE_CHART'), // chart title
      chartData: [], // Variable Importance Chart data
      // chartKey: 0, // Chart Refresh를 위한 key value
      collectionViewOptions: {}, // Feature Selection grid collectionView Option
      xCutoffValue: null, // x축 Cutoff value
      yCutoffValue: null, // y축 Cutoff value
      maxVariableCount: 100, // Max Variable Count - 최대 선택 수,
      paramList: [], // 선택된 module의 param list
      briqueChart: null // BriqueChart Component 객체
    }
  }
}
